import { Card, CardContent, CardHeader, Grid, Skeleton } from "@mui/material";

const WorkshopDetailsSkeleton = ({ isDesktop }) => {
  return (
    <Grid
      className='workshop-grid-item'
      size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      sx={{
        p: 0,
        mt: isDesktop ? "20px" : "8px !important",
      }}
    >
      <Card sx={{ padding: isDesktop ? undefined : "12px 16px" }}>
        {!isDesktop ? (
          <>
            {/* Workshop Name */}
            <Skeleton variant='text' width='50%' height={32} />

            {/* Address */}
            <Skeleton variant='text' width='75%' height={20} sx={{ mt: 1 }} />

            {/* Rating + Reviews + Distance */}
            <Grid container spacing={1} sx={{ mt: 1, alignItems: "center" }}>
              <Grid>
                <Skeleton variant='rounded' width={90} height={20} />
              </Grid>

              <Grid>
                <Skeleton variant='rounded' width={60} height={20} />
              </Grid>

              <Grid>
                <Skeleton variant='rounded' width={55} height={20} />
              </Grid>
            </Grid>

            {/* Extra Info */}
            <CardContent sx={{ px: 0, pb: 0 }}>
              <Skeleton variant='text' width='40%' />
              <Skeleton variant='text' width='95%' />
              <Skeleton variant='text' width='90%' />
              <Skeleton variant='text' width='85%' />

              <Skeleton variant='rectangular' height={90} sx={{ mt: 2, borderRadius: 2 }} />
            </CardContent>
          </>
        ) : (
          <>
            <CardHeader
              title={<Skeleton variant='text' width='35%' height={36} />}
              subheader={
                <>
                  <Skeleton variant='text' width='55%' />
                  <Skeleton variant='text' width='30%' />
                </>
              }
            />

            <CardContent>
              <Grid container spacing={2}>
                <Grid item size={{ xs: 6 }}>
                  <Skeleton variant='rounded' width={100} height={20} />
                  <Skeleton variant='rounded' width={80} height={20} sx={{ mt: 1 }} />
                </Grid>

                <Grid item size={{ xs: 6 }}>
                  <Skeleton variant='text' width='95%' />
                  <Skeleton variant='text' width='80%' />
                </Grid>
              </Grid>
            </CardContent>

            <CardContent>
              {/* ExtraInfo Skeleton */}
              <Skeleton variant='text' width='30%' />
              <Skeleton variant='text' width='100%' />
              <Skeleton variant='text' width='95%' />
              <Skeleton variant='text' width='85%' />

              <Skeleton variant='rectangular' height={120} sx={{ mt: 2, borderRadius: 2 }} />

              <Skeleton variant='text' width='90%' sx={{ mt: 2 }} />
              <Skeleton variant='text' width='80%' />
            </CardContent>
          </>
        )}
      </Card>
    </Grid>
  );
};

export default WorkshopDetailsSkeleton;
